var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
import { ButtonPrimary, ButtonSecondary, ButtonTertiary, TextLink, } from '@spotify-internal/encore-web';
import { useS4AMastheadContext, } from '../S4AMastheadProvider';
import adjustLinkHref from '../../utils/adjustLinkHref';
const UnstyledLink = styled.a `
  text-decoration: none !important;
  color: inherit;
`;
const UnstyledButton = styled.button `
  background: none;
  color: inherit;
  border: none;
  padding: 0;
  font: inherit;
  cursor: pointer;
`;
export const Link = (_a) => {
    var { children, href, openInNewWindow = false, trackingAttributes, dataTestId } = _a, rest = __rest(_a, ["children", "href", "openInNewWindow", "trackingAttributes", "dataTestId"]);
    const { onLinkClick, isFrodor } = useS4AMastheadContext();
    const { adjustedHref, useInternalNavigation } = adjustLinkHref(href, isFrodor, openInNewWindow);
    return useInternalNavigation ? (React.createElement(UnstyledButton, Object.assign({ onClick: () => onLinkClick({
            href: adjustedHref,
            external: false,
            trackingAttributes,
        }), "data-testid": dataTestId }, rest), children)) : (React.createElement(UnstyledLink, Object.assign({ onClick: () => onLinkClick({
            href,
            external: true,
            trackingAttributes,
        }), href: href, target: openInNewWindow ? '_blank' : undefined, "data-testid": dataTestId }, rest), children));
};
export const ButtonPrimaryLink = (_a) => {
    var { children, href, trackingAttributes, dataTestId, openInNewWindow = false } = _a, buttonProps = __rest(_a, ["children", "href", "trackingAttributes", "dataTestId", "openInNewWindow"]);
    const { onLinkClick, isFrodor } = useS4AMastheadContext();
    const { adjustedHref, useInternalNavigation } = adjustLinkHref(href, isFrodor, openInNewWindow);
    return (React.createElement(ButtonPrimary, Object.assign({ "data-testid": dataTestId, href: useInternalNavigation ? undefined : href, onClick: () => onLinkClick({
            href: adjustedHref,
            external: !useInternalNavigation,
            trackingAttributes,
        }) }, buttonProps), children));
};
export const ButtonSecondaryLink = (_a) => {
    var { children, href, openInNewWindow = false, trackingAttributes, dataTestId, onClick } = _a, buttonProps = __rest(_a, ["children", "href", "openInNewWindow", "trackingAttributes", "dataTestId", "onClick"]);
    const { onLinkClick, isFrodor } = useS4AMastheadContext();
    const { adjustedHref, useInternalNavigation } = adjustLinkHref(href, isFrodor, openInNewWindow);
    return (React.createElement(ButtonSecondary, Object.assign({ "data-testid": dataTestId, href: useInternalNavigation ? undefined : href, onClick: () => {
            onClick === null || onClick === void 0 ? void 0 : onClick();
            onLinkClick({
                href: adjustedHref,
                external: !useInternalNavigation,
                trackingAttributes,
            });
        } }, buttonProps), children));
};
export const ButtonTertiaryLink = (_a) => {
    var { children, href, openInNewWindow = false, trackingAttributes, dataTestId, onClick } = _a, buttonProps = __rest(_a, ["children", "href", "openInNewWindow", "trackingAttributes", "dataTestId", "onClick"]);
    const { onLinkClick, isFrodor } = useS4AMastheadContext();
    const { adjustedHref, useInternalNavigation } = adjustLinkHref(href, isFrodor, openInNewWindow);
    return (React.createElement(ButtonTertiary, Object.assign({ "data-testid": dataTestId, condensedAll: true, href: useInternalNavigation ? undefined : href, target: openInNewWindow ? '_blank' : undefined, onClick: () => {
            onClick === null || onClick === void 0 ? void 0 : onClick();
            onLinkClick({
                href: adjustedHref,
                external: !useInternalNavigation,
                trackingAttributes,
            });
        } }, buttonProps), children));
};
export const FrodorTextLink = (_a) => {
    var { children, href, openInNewWindow = false, trackingAttributes, onClick, dataTestId } = _a, buttonProps = __rest(_a, ["children", "href", "openInNewWindow", "trackingAttributes", "onClick", "dataTestId"]);
    const { onLinkClick, isFrodor } = useS4AMastheadContext();
    const { adjustedHref, useInternalNavigation } = adjustLinkHref(href, isFrodor, openInNewWindow);
    return (React.createElement(TextLink, Object.assign({ "data-testid": dataTestId, component: useInternalNavigation ? 'button' : 'a', href: useInternalNavigation ? '' : href, target: openInNewWindow ? '_blank' : undefined, onClick: () => {
            onClick === null || onClick === void 0 ? void 0 : onClick();
            onLinkClick({
                href: adjustedHref,
                external: !useInternalNavigation,
                trackingAttributes,
            });
        } }, buttonProps), children));
};
//# sourceMappingURL=Link.js.map